import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';

dayjs.extend(relativeTime);

/**
 * Returns a human-readable relative time string (e.g. "2 hours ago") for the given date in the given locale.
 */
export function formatRelativeTime(date: string, locale: string): string {
  return dayjs(date).locale(locale).fromNow();
}
